export default __webpack_public_path__ + "static/media/completed_mobile.39cc4002.svg";